<div class="main-nav-business-desktop">
  <div class="main-nav-business-desktop-container container">
    <div class="main-nav-business-desktop-content">
      <a
        class="main-nav-business-desktop-logo"
        [href]="items.businessPageRootLink">
        <img
          src="/assets/images/logo/logo-smarthead-business-turquoise.svg"
          title="SmartHead"
          [ngClass]="{ bigger: bigger }" />
      </a>

      <div
        class="main-nav-business-desktop-items"
        data-cy="main-nav-menu-items">
        <sh-main-nav-single-item-external [item]="items.pricingExternal"></sh-main-nav-single-item-external>
        <a
          href="https://docs.besmarthead.com/getting-started/introduction"
          target="_blank"
          >{{ 'header.resources' | transloco }}</a
        >
        <sh-main-nav-single-item [item]="items.mediaItem"></sh-main-nav-single-item>
        <sh-main-nav-about-us></sh-main-nav-about-us>
        <sh-main-nav-request-demo></sh-main-nav-request-demo>
        <sh-main-nav-login></sh-main-nav-login>
        <sh-main-nav-languages></sh-main-nav-languages>
      </div>
    </div>
  </div>
</div>
